// extracted by mini-css-extract-plugin
module.exports = {"phsForm":"_3--e7T2xh5zMZrRYgo9fEN","normalForm":"_2P_-pSkfcxDdUbKrPpONwh"};